import apiRequest from './api-request';
import type {
    DataDogClickMediumType,
    DataDogClickSourceType,
    DataDogClickTypeType
} from '../types/DataDogTypes';

const resource = 'datadog';

type ReportClicksProps = {
    utmSource: DataDogClickSourceType;
    utmMedium: DataDogClickMediumType;
    utmType: DataDogClickTypeType;
};

export default function reportClicks({
    utmSource,
    utmMedium,
    utmType
} : ReportClicksProps) {
    return apiRequest({
        method: 'GET',
        resource: `${resource}/clicks?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_type=${utmType}`
    });
}
